import Footer from 'Components/Home/Footer';
import Navbar from 'Components/Home/Navbar';
import MainHeadingSub from 'Components/MainHeading/MainHeadingSub';

import Summary from 'Components/Summary/Summary';
import Team from 'Components/Team/Team';
import Values from 'Components/VisionCoreValues/Values';
import React from 'react';
import aboutUsImg from 'Assets/elvotaimages/Heading/contactUsImg.jpg';
import FooterTop from 'Components/FooterTop/FooterTop';

export default function AboutUs() {
  const content = [
    'Evolta Technologies is a leading innovator in optimising battery energy storage systems (BESS) and advancing renewable energy integration, committed to enhancing asset value and driving sustainable growth in the clean energy sector.',
    'Our advanced AI and deep learning solutions deliver comprehensive real-time optimization for BESS operations, along with expert advisory services that equip asset owners with precise long-term forecasting and revenue maximization. From day-to-day market operations to strategic project planning, we provide end-to-end support for energy storage success.',
    'Our team is a passionate group of talented experts, united by a shared mission to accelerate the energy transition through innovative technology and a relentless drive for impact.',
  ];
  return (
    <div>
      <Navbar />
      <MainHeadingSub
        simple="The Pioneers of Energy Storage "
        highlighted="Innovation"
        imageSrc={`linear-gradient(0deg, rgba(17, 64, 54, 0.3), rgba(17, 64, 54, 0.3)), url(${aboutUsImg})`}
      />
      <div className="main-container">
        <Summary paragraph={content} />
      </div>
      <div className="additional-bg">
        <div className="main-container">
          <Team />
        </div>
      </div>
      <div className="main-container lg:pb-[250px] pb-[150px]">
        <Values />
      </div>
      <FooterTop />
      <Footer />
    </div>
  );
}
